import { inject, injectable } from "inversify";
import { Either } from "@core/domain/types/either";
import { FallbackError } from "@core/domain/errors/fallback.error";
import { ValidationError } from "@core/domain/errors/validation.error";
import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { FinancialEntityBudget } from "@project/domain/models/budget/financial-entity-budget.model";
import { BudgetTemplateRepositoryAbstract } from "@project/domain/repositories/budget-template.repository.abstract";
import { mapBudgetTemplateError } from "@project/domain/errors/budget-template.errors";

@injectable()
export class CreateTemplateFromTemplateUseCase {
    constructor(
        @inject(BudgetTemplateRepositoryAbstract)
        private readonly budgetTemplateRepository: BudgetTemplateRepositoryAbstract,
    ) { }

    async execute(templateId: number, name: string, description: string): Promise<Either<ValidationError | FallbackError, FinancialEntityBudget>> {
        const result = await this.budgetTemplateRepository.createTemplateFromTemplate(
            templateId,
            name,
            description,
        );
        if (result.isLeft()) {
            const mapped = mapBudgetTemplateError(result.getLeftOrThrow());
            ToastManagerStore.error(mapped.message);
        }
        return result;
    }
}
